import { render, staticRenderFns } from "./confirmAccount.vue?vue&type=template&id=ee60722e&scoped=true"
import script from "./confirmAccount.vue?vue&type=script&lang=js"
export * from "./confirmAccount.vue?vue&type=script&lang=js"
import style0 from "./confirmAccount.vue?vue&type=style&index=0&id=ee60722e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee60722e",
  null
  
)

export default component.exports